import styled from "@emotion/styled";
import { IonSpinner } from "@ionic/react";
import { FC } from "react";

const SpinnerContainer = styled.div`
  text-align: center;
  padding-top: 10px;
`;

interface InlineLoaderProps {
  loading: boolean;
}

const InlineLoader: FC<InlineLoaderProps> = ({ loading }) => (
  <SpinnerContainer hidden={!loading}>
    <IonSpinner />
  </SpinnerContainer>
);

export { InlineLoader };
